import { useEffect, useState } from "react";

type UseSetDropdownOpenProps = {
  /** The ref of the container */
  containerRef: React.RefObject<HTMLDivElement | null>;
};

/** Custom hook to set the dropdown open state. */
const useSetDropdownOpen = ({ containerRef }: UseSetDropdownOpenProps) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!containerRef.current) return;
    if (!isOpen) return;

    const handleClickOutside = (event: PointerEvent) => {
      if (!containerRef.current?.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("pointerdown", handleClickOutside);

    return () => {
      document.removeEventListener("pointerdown", handleClickOutside);
    };
  }, [containerRef, isOpen, setIsOpen]);

  return { isOpen, setIsOpen };
};

export default useSetDropdownOpen;
